module.exports = __webpack_public_path__ + "img/right-arrow-icon.6f0be5d2.svg";